import {
  Box,
  DialogTitle,
  Grid,
  Modal,
  TextField,
  Divider,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";

// import { getAllCustomerDetail,  } from "./api";
import { searchedElementDisplay } from "../advancePayment/receiptFunctions";
import {
  getAllCustomerDetail,
  getLastDetail,
} from "../../common/searchModal/api";
import UserCard from "../advancePayment/userCard";
import { getAllIncentive } from "./paymentApi";

const PoprchModal = ({
  searchModal = false,  // Ensure it's a boolean
  setSearchModal = () => {}, // Ensure it's a function
  config = {}, // Default to empty object
  callback = () => {}, // Default empty function
  cardValue = null, // Default null
  setCardValue = () => {}, // Default empty function
  // userDetail,
}) => {
  const [collection, setCollection] = useState([]);
  const [searchCurrentModal, setSearchCurrentModal] = useState("");
  const getCounterSalesCusomter = async (param) => {
    // await getCounterSalesCustomers(param).then((res) => {
    //   console.lo g("countersales res data   ", res?.data?.data, " ", {
    //     page: res.data.pageNumber,
    //     total: res.data.totalPages,
    //   });
    //   setPagination({
    //     page: res.data.pageNumber,
    //     total: res.data.totalPages,
    //   });
    //   console.log("res?.data",res?.data?.data?.list)
    //   setUnPaidBill([...res?.data?.data?.list]);
    // });
  };
  useEffect(() => {
    console.log("dddd");
    if (searchModal === true) {
      getAllIncentive((data) => {
        console.log("data detail ", data?.data?.data?.list);
        setCollection(data?.data?.data?.list);
      });
      //   getCounterSalesCusomter({
      //     filter: "",

      //     search: "",
      //     page: 1,
      //     pageSize: 1000,
      //   });
      //   setBillData({ ...billData, mybusinessId: userDetail?.myBusinessId });
    } else {
      console.log("close");
      //   setBillData(data);
      //   setUnPaidBillData();

      //   setSearchCurrentModal("")
    }
  }, [searchModal]);
  return (
    <Modal
      open={searchModal}
      sx={{ zIndex: 999999 }} // Yo
      onClose={() => {
        setSearchModal(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Grid
        container
        sx={{
          // backgroundColor: "white",
          // width:"40%"
          background: "white",
          width: "40%",
          overflowY: "auto",
          height: "70vh",
          position: "absolute",
          left: "30%",
          top: "10%",
        }}
      >
        <Grid item xs={12}>
          <DialogTitle
            color="primary"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              m: 0,
              pr: "10px",
            }}
          >
            Assistant list{" "}
            <CloseIcon
              sx={{ float: "right", cursor: "pointer" }}
              onClick={() => {
                setSearchModal(false);
              }}
            />
          </DialogTitle>
          <Divider />
          <Box sx={{ mt: 1, textAlign: "center", px:"20px"}}>
            <TextField
              sx={{ width: "100%" }}
              size="small"
              label="Search by Name/Mobile Number"
              value={searchCurrentModal}
              onChange={(e) => {
                setSearchCurrentModal(e.target.value);
              }}
              InputProps={{
                endAdornment: (
                  <SearchIcon
                    sx={{
                      color: (theme) => theme.palette.primary.main,
                    }}
                  />
                ),
              }}
            />
            
          </Box>
          <Box sx={{ height: "55vh", overflowY: "auto", px:"20px"}}>
            {collection.map((item, index) => {
             
              if (config?.salary && item?.salaryorPercentage !== true) {
                return null;
              }
              return ( 
                <UserCard
                  key={"employee" + index}
                  data={item}
                  callBack={(data) => {
                    setCardValue(data); 
                    setSearchModal(false);
                  }}
                />
              );
            })}
          </Box>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default PoprchModal;
